<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.specialties', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-specialty' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mSpecialties"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="specialties-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mSpecialties"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data" v-if="can">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-specialty', params: { specialty: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.specialties', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.nom }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteSpecialty(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="specialties-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    import moment from 'moment';

    export default {
        name: "Specialties",

        computed: {
            ...mapGetters(["specialties",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },
            mSpecialties: function() {
                let sArray = [];

                _.forEach(this.specialties, function(specialty) {
                    let s = {};

                    s.nom = specialty.name;
                    s.profession = specialty.profession.name;
                    s.date = moment(specialty.created_at).format('DD-MM-YYYY HH:mm');
                    s.id = specialty.id;
                    s.slug = specialty.slug;

                    sArray.push(s);
                });

                return sArray;
            },

            rows: function() {
                return this.mSpecialties.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'nom',
                        label: this.$i18n.t('message.name')
                    },
                    {
                        key: 'profession',
                        label: this.$i18n.tc('message.professions', 1)
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getSpecialties() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getSpecialties', { args : args });
            },

            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                this.$router.push({ name: 'specialty', params: { specialty: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'specialty', params: { specialty: items[0].slug } });
            },

            deleteSpecialty(specialty) {
                let self = this;

                let args = {
                    specialty: specialty
                };

                let successMessage = this.$i18n.t('message.specialtyDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteSpecialty', { args, index: specialty, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + specialty);
                    });
            }
        },

        mounted() {
            // Fetch specialty list
            this.getSpecialties();
        }
    }
</script>

<style scoped>

</style>